'use es6';

import PropTypes from 'prop-types';
import { cloneElement, Children, Component } from 'react';
import { DragLayer } from 'react-dnd-compat';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const DragLayerContainer = styled.div.withConfig({
  displayName: "CustomDragLayer__DragLayerContainer",
  componentId: "uidhq1-0"
})(["position:fixed;pointer-events:none;z-index:0;left:0;top:0;width:100%;height:100%;"]);
const DragItem = styled.div.attrs(props => {
  const {
    initialOffset,
    currentOffset
  } = props;
  if (!initialOffset || !currentOffset) {
    return {
      style: {
        display: 'none',
        transform: 'none'
      }
    };
  }
  const {
    x,
    y
  } = currentOffset;
  return {
    style: {
      display: 'block',
      transform: `translate(${x}px, ${y}px)`
    }
  };
}).withConfig({
  displayName: "CustomDragLayer__DragItem",
  componentId: "uidhq1-1"
})([""]);
class CustomDragLayer extends Component {
  renderItem() {
    const {
      item,
      children
    } = this.props;
    if (!item.useCustomDragLayer) {
      return null;
    }
    const child = Children.only(children);
    return /*#__PURE__*/cloneElement(child, {
      item
    });
  }
  render() {
    const {
      isDragging,
      itemType,
      namespace,
      initialOffset,
      currentOffset
    } = this.props;
    if (!isDragging || namespace && namespace !== itemType) {
      return null;
    }
    return /*#__PURE__*/_jsx(DragLayerContainer, {
      children: /*#__PURE__*/_jsx(DragItem, {
        initialOffset: initialOffset,
        currentOffset: currentOffset,
        children: this.renderItem()
      })
    });
  }
}
CustomDragLayer.propTypes = {
  namespace: PropTypes.string,
  children: PropTypes.node,
  isDragging: PropTypes.bool.isRequired,
  item: PropTypes.object,
  itemType: PropTypes.string,
  initialOffset: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),
  currentOffset: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  })
};
export { CustomDragLayer as WrappedComponent };
export default DragLayer(monitor => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  initialOffset: monitor.getInitialSourceClientOffset(),
  currentOffset: monitor.getSourceClientOffset(),
  isDragging: monitor.isDragging()
}))(CustomDragLayer);